import http from 'plugins/axios'

export default {
  //旧的账单接口
  // reqList(data) {
  //   return http.get({
  //     url: '/ta/admin/transfer/list',
  //     data
  //   });
  // },
  //新账单接口
  //获取转账类型
  getTransferType() {
    return http.get({
      url: '/ta/admin/public/transfer/type',
    })
  },
  reqList(data) {
    return http.get({
      url: `/ta/admin/balance/bill/getInternalTransferRecordList`,
      data
    })
  },
  create(data) {
    return http.post({
      url: '/ta/admin/transfer/create',
      data,
      dataType: 'form',
    })
  },
  transfer({ userId, coin, amount, type }) {
    return http.post({
      url: `/ta/admin/public/transfer?userId=${userId}&coin=${coin}&amount=${amount}&type=${type}`,
    })
  },
  mockTransfer({ userId, coin, amount, type }) {
    return http.post({
      url: `/ta/admin/public/transfer/mock?userId=${userId}&coin=${coin}&amount=${amount}&type=${type}`,
    })
  },
  getCoinTypes() {
    return http.get({
      url: '/ta/admin/tenant/coin/allDisplay',
    })
  },
}
